@if (windowService.isDesktopRes) {
  <tidy-desktop-header #accessHeader>
    <div class="wrappable-container">
      <tidy-text [header]="'Access'" />
      <tidy-small-button
        [text]="'Connect Locks'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="goToConnectLocks()" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'access'" />
    </div>
  </tidy-desktop-header>
}

@if (!windowService.isDesktopRes) {
  <div style="display: flex; gap: 8px; margin-bottom: 10px;">
    <tidy-small-button
      [text]="'Connect Locks'"
      [image]="'assets/img/add-button-white.svg'"
      (buttonClick)="goToConnectLocks()" />
  </div>
}

<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (!loaded && windowService.isDesktopRes) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

@if (!loaded && !windowService.isDesktopRes) {
  <div style="width: 100%; margin-bottom: 12px;">
    <ion-skeleton-text animated="true" style="height: 40px; border-radius: 6px" />
  </div>
  @for (i of [1,2,3,4,5]; track i) {
    <div style="width: 100%; margin-bottom: 6px;">
      <ion-skeleton-text animated="true" style="height: 44px; border-radius: 4px" />
    </div>
  }
}

@if (loaded) {
  @if (!hasIntegration) {
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="'Connect a smart lock integration to manage access for your properties.'" />
      </tidy-row>
    </tidy-alert>
  }

  @if (hasIntegration && shownRows.length === 0) {
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="'No smart locks found. Locks synced from your integration will appear here.'" />
      </tidy-row>
    </tidy-alert>
  }

  @if (hasIntegration && shownRows.length > 0 && windowService.isDesktopRes) {
    <tidy-table
      [dataSource]="shownRows"
      [displayedColumns]="headers"
      [columnslabels]="columnLabels"
      [showColumnLines]="false"
      [allRowIsClickable]="false"
      [skipEntrance]="true"
      [blockSorting]="true"
      [showArrowIcon]="false"
      (cellClick)="onCellClick($event)" />
  }

  @if (hasIntegration && shownRows.length > 0 && !windowService.isDesktopRes) {
    @for (row of shownRows; track row['Lock'].value) {
      <tidy-card>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/lock-closed-outline.svg'" class="body-size" />
          <tidy-text [body]="row['Lock'].value" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          @if (row.tagColor) {
            <tidy-tag [color]="row.tagColor" [addressId]="row.firstAddressId" />
          }
          <tidy-text [helper]="row['Properties'].value" [translate]="false" />
        </tidy-row>
        <tidy-row>
          <tidy-text [helper]="row.statusLabel" />
        </tidy-row>
        @if (row.remoteAccessDeviceId) {
          <tidy-row class="align-right">
            <tidy-text
              [actionBody]="'Generate Access Code'"
              (action)="openTestCode(row.remoteAccessDeviceId)"
              class="link" />
          </tidy-row>
        }
      </tidy-card>
    }
  }
}

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'access'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}
